import { Button, ButtonsGrid } from 'components/common/button/button';
import AmountWithMax from 'components/common/form/amount-with-max/amount-with-max';

import {
  StyledContainer,
  StyledSection,
  StyledTitle,
  StyledSubTitle,
  StyledTextRight,
  StyledAmountWrapper
} from './views.style';

const RevokeView = ({ closeModal }: { closeModal: () => void }) => {
  const amount = '175.50';

  const onClickHandler = () => {
    closeModal();
  };

  return (
    <StyledContainer>
      <StyledSection p="48px 65px">
        <StyledTitle bold>Withdraw OPN</StyledTitle>
        <StyledSubTitle secondary>
          Remove your OPN from the pool.
        </StyledSubTitle>
        <StyledTextRight>Pool Balance: {amount}</StyledTextRight>
        <StyledAmountWrapper mb={4}>
          <AmountWithMax opnColor="#1c505d" />
        </StyledAmountWrapper>
        <ButtonsGrid>
          <Button size="big" fullwidth onClick={onClickHandler}>
            Revoke OPN
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default RevokeView;
